import { Checkbox, Space } from "antd";

import { motion } from "framer-motion";
import { useState } from "react";
import { useExamStore } from "@store";

export const MultipleChoiceOption = () => {
  const currentQuestion = useExamStore((state) => state.clickedQuestion);

  const [checkedList, setCheckedList] = useState<any[]>();
  const onChange = (list: any[]) => {
    setCheckedList(list);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Checkbox.Group value={checkedList} onChange={onChange}>
        <Space direction="vertical">
          {currentQuestion?.answers.map((answer, index) => (
            <Checkbox key={index} value={index}>
              {answer.value}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </motion.div>
  );
};
